const taskLang = {
  label: 'Tâche',
  categories: {
    menu: 'Catégories des tâches',
    pageTitle: 'Gestion des catégories des tâches',
    new: 'Création d\'une catégorie de tâche',
    edit: 'Modification d\'une catégorie de tâche',
    deleteMsg: 'Êtes-vous sûr de vouloir supprimer cette catégorie de tâche ?',
    label: 'Nom de la catégorie',
    all: 'Toutes'
  },
  pageTitle: 'Liste des tâches',
  addTitle: 'Création d\'une tâche',
  editTitle: 'Modification d\'une tâche',
  newBtn: 'Créer une tâche',
  noResults: 'Aucun résultat',
  noTasks: 'Aucune tâche',
  tabTitle: 'Tâches',
  searchTypesPlaceholder: 'Rechercher un client, un contact ou un autre élément auquel rattacher cette tâche',
  headerNewTask: '+ Créer une tâche +',
  headerMoreTask: '{count} tâche de plus|{count} tâches de plus',
  headerNoTask: 'Aucune tâche',
  headerSeeAllTask: 'Voir toutes les tâches',
  searchTypes: {
    customer: 'Tiers',
    contact: 'Contact',
    affair: 'Affaire',
    quotation: 'Devis',
    command: 'Bon de commande',
    delivery: 'Bon de livraison',
    proforma: 'Facture proforma',
    invoice: 'Facture',
    credit: 'Avoir',
    provider_command: 'Commande'
  },
  deleteMsg: 'Êtes-vous sûr de vouloir supprimer cette tâche ?',
  myTask: 'Mes tâches',
  allTasks: 'Toutes les tâches',
  other: 'Autre',
  archive: 'Archiver',
  archiveMsg: 'Êtes-vous sûr de vouloir archiver cette tâche ?',
  archiveExplain: 'Celle-ci sera toujours visible depuis la liste des tâches mais elle n\'apparaîtra plus sur les différentes fiches.',
  unarchive: 'Désarchiver',
  unarchiveMsg: 'Êtes-vous sûr de vouloir désarchiver cette tâche ?',
  status: {
    1: 'À faire',
    2: 'En cours',
    3: 'En attente',
    4: 'Terminée',
    '-1': 'Tous',
    '-2': 'Non terminée'
  },
  priorities: {
    1: 'Faible',
    2: 'Normale',
    3: 'Urgente',
    '-1': 'Toutes'
  },
  views: {
    state: 'États',
    chronological: 'Chronologique',
    priorities: 'Priorités',
    categories: 'Catégories',
    users: 'Utilisateurs',
    list: 'Liste',
    tooLate: 'En retard',
    today: 'Aujourd\'hui',
    tomorrow: 'Demain',
    later: 'Plus tard',
    status: 'Statut',
    display: 'Affichage',
    vue: 'Vue',
    noCategory: 'Aucune catégorie n\'est affichée.',
    noCategory2: 'Cliquez sur le bouton affichage, situé en haut à droite, pour sélectionner les catégories à afficher.'
  },
  list: {
    date: 'Date',
    customers: 'Client(s)',
    contacts: 'Contact(s)',
    title: 'Titre',
    category: 'Catégorie',
    status: 'Statut',
    notes: 'Observations',
    priority: 'Priorité',
    elements: 'Élément(s) lié(s)',
    users: 'Utilisateur(s)',
    completedDate: 'Date de réalisation',
    createdDate: 'Date de création',
    updatedDate: 'Date de modification'
  },
  form: {
    title: 'Titre',
    date: 'Date',
    category: 'Catégorie',
    state: 'État',
    comments: 'Observations',
    owner: 'Propriétaire(s) de la tâche',
    priority: 'Priorité'
  },
  config: {
    modalTitle: 'Configuration des tâches',
    defaultParams: 'Paramètres par défaut pour la création des nouvelles tâches :',
    date: 'Date de la tâche :',
    currentDate: 'Date du jour',
    days: 'jours',
    owner: 'Propriétaire(s) des tâches :',
    interfaceTitle: 'Affichage des tâches dans l\'interface',
    laterCategory: 'Dans la catégorie "Plus tard", afficher les tâches sur :',
    top: 'Dans la partie haute de l\'interface, afficher les notifications sur :',
    mailTitle: 'Notifications par email',
    mailNotification: 'Recevoir la liste des tâches à faire par email :',
    mailHour: 'Heure d\'envoi de l\'email :',
    never: 'Jamais',
    allDays: 'Tous les jours',
    monday: 'Tous les lundi',
    displayTitle: 'Options d\'affichage',
    opacityView: 'Ne pas griser les tâches terminées sur la page des tâches',
    opacityTimeline: 'Ne pas griser les tâches terminées dans les timelines sur les différentes fiches'
  }
}

export default {
  tasks: taskLang
}
